import { useQuery } from '@tanstack/react-query'
import { api } from '@/shared/lib/api'
import { ApiError } from '@/shared/lib/http'
import type { ProblemMatch } from '@/shared/lib/apiTypes'

export function useProblemMatches(problemCardId: string | undefined) {
  return useQuery({
    queryKey: ['problem-matches', problemCardId],
    queryFn: (): Promise<{ items: ProblemMatch[] }> =>
      api.problemMatches(problemCardId ?? '').catch((err: unknown) => {
        if (err instanceof ApiError && err.status === 404) return { items: [] }
        throw err
      }),
    enabled: problemCardId !== undefined,
    retry: false,
  })
}
